// EM²c ACTIVE production/resource chains.
// Removed Construction Yard, Mining Processor, ice chain and duplicate factories.
// Construction happens directly on site by drones/rovers.

export const NEW_RESOURCES = {
  raw_water: { id: "raw_water", label: "Raw Water", unit: "L", color: "#4682b4", icon: "Droplet" },
  metal_ore: { id: "metal_ore", label: "Metal Ore", unit: "t", color: "#8a4020", icon: "Mountain" },
  iron: { id: "iron", label: "Iron", unit: "t", color: "#a76f55", icon: "Layers" },
  aluminum: { id: "aluminum", label: "Aluminum", unit: "t", color: "#bfc6ce", icon: "Layers" },
  copper: { id: "copper", label: "Copper", unit: "t", color: "#c97945", icon: "Layers" },
  silicon: { id: "silicon", label: "Silicon", unit: "t", color: "#8b7f9b", icon: "Gem" },
  regolith: { id: "regolith", label: "Regolith", unit: "t", color: "#a0522d", icon: "Mountain" },
  refinery_tailings: { id: "refinery_tailings", label: "Refinery Tailings", unit: "t", color: "#76645a", icon: "Mountain" },
  construction_material: { id: "construction_material", label: "Building Material", unit: "u", color: "#b98a66", icon: "Box" },
  structural_components: { id: "structural_components", label: "Structural Components", unit: "u", color: "#cd853f", icon: "Box" },
  machine_parts: { id: "machine_parts", label: "Machine Parts", unit: "u", color: "#e8a37e", icon: "Cog" },
  electronic_components: { id: "electronic_components", label: "Electronics", unit: "u", color: "#4169e1", icon: "Cpu" },
  utility_components: { id: "utility_components", label: "Utility Components", unit: "u", color: "#daa520", icon: "Wrench" },
  processed_minerals: { id: "processed_minerals", label: "Processed Minerals", unit: "t", color: "#9370db", icon: "Gem" },
  organic_waste: { id: "organic_waste", label: "Organic Waste", unit: "kg", color: "#6b8e23", icon: "Trash" },
  wastewater: { id: "wastewater", label: "Wastewater", unit: "L", color: "#556b2f", icon: "Droplet" },
  recyclable_material: { id: "recyclable_material", label: "Recyclable Material", unit: "u", color: "#8b8d85", icon: "Recycle" },
  fertilizer: { id: "fertilizer", label: "Fertilizer", unit: "kg", color: "#8b6b3b", icon: "Sprout" },
  research_points: { id: "research_points", label: "Research Points", unit: "RP", color: "#00fa9a", icon: "FlaskConical" },
  medical_supplies: { id: "medical_supplies", label: "Medical Supplies", unit: "u", color: "#ff6688", icon: "Cross" },
  mission_supplies: { id: "mission_supplies", label: "Mission Supplies", unit: "u", color: "#b9c5d5", icon: "Package" },

  // Closed-loop gas economy
  hydrogen: { id: "hydrogen", label: "Hydrogen", unit: "kg", color: "#b9e6ff", icon: "Wind" },
  methane: { id: "methane", label: "Methane", unit: "kg", color: "#b7f0cf", icon: "Wind" },
  co2: { id: "co2", label: "CO₂", unit: "kg", color: "#7b7b7b", icon: "Wind" },
  nitrogen: { id: "nitrogen", label: "Nitrogen", unit: "kg", color: "#87ceeb", icon: "Wind" },
  argon: { id: "argon", label: "Argon", unit: "kg", color: "#c2a5ff", icon: "Wind" },
  carbon_monoxide: { id: "carbon_monoxide", label: "CO Process Gas", unit: "kg", color: "#9a8e82", icon: "Wind", hidden: true },
  rocket_propellant: { id: "rocket_propellant", label: "Rocket Propellant", unit: "u", color: "#ff6347", icon: "Rocket" },
};

export const NEW_RESOURCE_TYPES = NEW_RESOURCES;

// Any building can use the recipe engine; the name is kept for compatibility.
export const FACTORY_RECIPES = {
  factory_complex: [
    {
      id: "machine_parts",
      name: "Machine Parts",
      inputs: { iron: 2, aluminum: 0.5 },
      outputs: { machine_parts: 1 },
      time: 12,
      workers: 1,
      bootstrapDefault: true,
    },
    {
      id: "electronics",
      name: "Electronics",
      inputs: { copper: 1, silicon: 1 },
      outputs: { electronic_components: 1 },
      time: 15,
      workers: 1,
    },
    {
      id: "utility_components",
      name: "Utility Components",
      inputs: { aluminum: 1, copper: 0.5, polymers: 0.5 },
      outputs: { utility_components: 1 },
      time: 14,
      workers: 1,
    },
    {
      id: "structural_components",
      name: "Structural Components",
      inputs: { iron: 2, aluminum: 1 },
      outputs: { structural_components: 1 },
      time: 14,
      workers: 1,
    },
    {
      id: "additive_structures",
      name: "Additive Structural Printing",
      inputs: { construction_material: 2, polymers: 0.5 },
      outputs: { structural_components: 1 },
      time: 10,
      workers: 1,
      requiresResearch: "eng_mfg1",
    },
  ],

  regolith_processor: [
    {
      id: "regolith_construction_material",
      name: "Regolith Building Material",
      inputs: { regolith: 4 },
      outputs: { construction_material: 3 },
      time: 10,
      workers: 0,
      bootstrapDefault: true,
    },
    {
      id: "tailings_recovery",
      name: "Tailings Recovery",
      inputs: { refinery_tailings: 3 },
      outputs: { construction_material: 2, processed_minerals: 0.5 },
      time: 10,
      workers: 0,
    },
  ],

  waste_recycler: [
    {
      id: "recycle_salvage",
      name: "Recycle Demolition Salvage",
      inputs: { recyclable_material: 2 },
      outputs: { construction_material: 1, iron: 0.5 },
      time: 10,
      workers: 0,
      bootstrapDefault: true,
    },
    {
      id: "biomass_digest",
      name: "Biomass Digestion",
      inputs: { organic_waste: 2 },
      outputs: { methane: 0.5, co2: 0.25, fertilizer: 0.5 },
      time: 10,
      workers: 0,
    },
    {
      id: "wastewater_recovery",
      name: "Wastewater Recovery",
      inputs: { wastewater: 2 },
      outputs: { water: 1.5 },
      time: 8,
      workers: 0,
    },
  ],

  gas_refinery: [
    {
      id: "co_methanation",
      name: "CO Methanation",
      inputs: { carbon_monoxide: 1, hydrogen: 2 },
      outputs: { methane: 1, water: 0.5 },
      time: 12,
      workers: 0,
      bootstrapDefault: true,
    },
    {
      id: "co2_sabatier",
      name: "CO₂ Sabatier Conversion",
      inputs: { co2: 1, hydrogen: 4 },
      outputs: { methane: 1, water: 2 },
      time: 14,
      workers: 0,
    },
  ],

  propellant_refinery: [
    {
      id: "methalox_propellant",
      name: "Methane / Oxygen Propellant",
      inputs: { methane: 1, oxygen: 2 },
      outputs: { rocket_propellant: 1 },
      time: 12,
      workers: 0,
      bootstrapDefault: true,
    },
  ],
};

// Kept as an empty compatibility export so old imports cannot resurrect the
// removed Construction Yard chain.
export const CONSTRUCTION_YARD_RECIPES = Object.freeze({});

export const PRODUCTION_CHAINS = [
  {
    id: "mining_chain",
    name: "Metal Extraction & Manufacturing",
    description: "Metal Deposit → Mining Outpost → Metal Ore → Ore Refinery → separated metals → Factory Complex.",
    stages: [
      { building: "mining_outpost", input: null, output: "metal_ore" },
      { building: "ore_refinery", input: "metal_ore", output: "iron" },
      { building: "factory_complex", input: "iron", output: "machine_parts" },
    ],
  },
  {
    id: "regolith_chain",
    name: "Regolith Construction Material",
    description: "Martian regolith and refinery residue become on-site foundation and hard-structure material.",
    stages: [
      { building: "regolith_processor", input: "regolith", output: "construction_material" },
    ],
  },
  {
    id: "water_chain",
    name: "Closed-Loop Water",
    description: "Hydrated Mineral Zone → Regolith Water Extractor → Raw Water → purification → Clean Water.",
    stages: [
      { building: "water_extractor", input: null, output: "raw_water" },
      { building: "water_tank", input: "raw_water", output: "raw_water" },
      { building: "water_purifier", input: "raw_water", output: "water" },
      { building: "clean_water_reservoir", input: "water", output: "water" },
    ],
  },
  {
    id: "food_chain",
    name: "Food Production",
    description: "Agriculture → Cold Food Storage → Food Processing.",
    stages: [
      { building: "greenhouse", input: "water", output: "food" },
      { building: "food_storage", input: "food", output: "food" },
      { building: "food_processing", input: "food", output: "food" },
    ],
  },
  {
    id: "gas_chain",
    name: "Closed-Loop Gas Recovery",
    description: "Colony gas outputs are recovered, converted where needed and stored for reuse.",
    stages: [
      { building: "oxygen_gen", input: "water", output: "hydrogen" },
      { building: "atmo_processor", input: null, output: "co2" },
      { building: "gas_refinery", input: "carbon_monoxide", output: "methane" },
      { building: "gas_storage", input: "methane", output: "methane" },
    ],
  },
  {
    id: "propellant_chain",
    name: "Mars Rocket Propellant",
    description: "Stored Methane + dedicated Oxygen storage → Propellant Refinery → Propellant Tank Farm → rockets.",
    stages: [
      { building: "gas_storage", input: "methane", output: "methane" },
      { building: "oxygen_tank", input: "oxygen", output: "oxygen" },
      { building: "propellant_refinery", input: "methane", output: "rocket_propellant" },
      { building: "propellant_tank_farm", input: "rocket_propellant", output: "rocket_propellant" },
      { building: "landing_pad", input: "rocket_propellant", output: null },
    ],
  },
  {
    id: "recycling_chain",
    name: "Construction Recycling",
    description: "Completed buildings create age-based recyclable salvage; the Waste Recycling Plant recovers usable materials.",
    stages: [
      { building: "waste_recycler", input: "recyclable_material", output: "construction_material" },
    ],
  },
];
